import React from 'react';
import fetch from 'isomorphic-fetch';
import _ from 'lodash'; // eslint-disable-line
import { Route, IndexRoute, IndexRedirect, browserHistory } from 'react-router';
import { ROUTES_PLP_LEAD_CARD } from './cards/constants/Cards';
import App from './App';
import NotFoundv2 from './pages/NotFoundv2';

import CreateFlow from './components/onboard/CreateFlow';
// import OnboardContainer from './components/onboard/OnboardContainer';
import SignupIntent from './pages/preauth/SignupIntentPage';
import SignupPageContainer from './pages/preauth/SignupPageContainer';
import LoginPageContainer from './pages/preauth/LoginPageContainer';
import ForgotPasswordPage from './pages/preauth/ForgotPasswordPage';

import ThemesContainer from './components/manage/website/ThemesContainer';
import ThemeDetail from './components/manage/website/ThemeDetail';
import EditPage from './components/manage/website/EditPage';
import ManagePages from './components/manage/website/ManagePages';
import ManagePagesRedesign from './components/manage/website/ManagePagesRedesign/ManagePagesRedesign';
import WeddingPartyV2 from './components/PublicWebsite/pages/WeddingPartyV2';
import Poi from './components/PublicWebsite/pages/Poi';
import PoiV2 from './components/PublicWebsite/pages/PoiV2';
import Faq from './components/PublicWebsite/pages/Faq';
import Registry from './components/PublicWebsite/pages/Registry';
import Photos from './components/PublicWebsite/pages/Photos';
import Travel from './components/PublicWebsite/pages/Travel';
import Events from './components/PublicWebsite/pages/Events';
import Home from './components/PublicWebsite/pages/Home';
import MobileLandingPage from './components/onboard/MobileLanding/MobileLandingPage';
import Credits from './components/Credits';
import PreAuthApp from './pages/preauth/PreAuthApp';
import Directory from './components/manage/guestlist/Directory';
import Build from './components/manage/guestlist/Build';
import AddressEnvelopes from './components/manage/guestlist/AddressEnvelopes';
import RsvpOverview from './components/manage/guestlist/RsvpOverview';
import TrackRsvpNotifications from './components/manage/guestlist/trackRsvpNotifications/TrackRsvpNotifications';
import multipleRsvpNotifications from './components/manage/guestlist/trackRsvpNotifications/MultipleRsvpNotifications'; // eslint-disable-line
import AddGuestPage from './components/manage/guestlist/addGuestPage/AddGuestPage';
import RsvpEvent from './components/manage/guestlist/RsvpEvent';
import { getWeddingBySlug, getWeddingPreviewBySlug, getWeddingByHashId, getRsvpByGuestGroupUuid, getGuestRequestCount, storeMobileToken } from './actions/PublicWebsiteActions';
import { getUserContext } from './actions/UserActions';
import { fetchWeddingAccount } from './actions/WeddingActions';
import { fetchEventsRsvpPage } from './actions/EventActions';
import { fetchChart, fetchChartList, finishOnboarding } from './actions/SeatingChartActions';
import fetchPromotion from './actions/PromotionActions';

import RsvpBase from './components/PublicWebsite/pages/RsvpBase';
import UrlContainer from './components/settings/url/UrlContainer';
import WeddingDetailsContainer from './components/settings/wedding/WeddingDetailsContainer';
import PrivacySettings from './components/settings/PrivacySettings';

// card actions
import {
  getCardSuite,
  updateSearchFilters as updateCatalogSearchFilters,
  updateCatalogAdminView,
  getCollaborators,
} from './cards/actions/cardCatalogActions';
import { actions as projectActions } from './cards/actions/projectActions';
import { customizationCleanUp } from './cards/actions/cardCustomizationActions';

// card selectors
import {
  getProjectUUID,
  getSteps
} from './cards/selectors/cardProjectSelector';

// util
import FeatureFlags from './util/featureFlags';
import inOptimizelyExperiment, { shouldGoToTestPage } from './util/optimizelyHelper';
import { weddingDashboardEditorialWithNoDekOptimizelyConfig, managePageRedesignOptimizelyVariation1 } from './util/optimizelyConfigs';

// import AccountSettings from './pages/AccountSettings';
// import { THEMES_REQUESTED } from './actions/types/website/ThemeListingActionTypes';
// import { resetFacetValues } from './actions/GuestActions';

// call updateBoxShadow (which is set in web-nav) becuz if you visit a weddings page with no sub-nav (ie, web-nav has a dropshadow),
// and then navigate to a weddings page with a sub-nav, it should update web-nav to NOT have a dropshadow (and vice versa);
browserHistory.listen((location) => {
  if (location.pathname) {
    if (window.zolaNav && window.zolaNav.updateBoxShadow) {
      window.zolaNav.updateBoxShadow(location.pathname);
    }
  }
});

const getRoutes = (store) => {
  const redirect = ({ to, useSlug }) => ((nextState) => {
    const slug = useSlug ? `/${nextState.params[useSlug]}` : '';
    window.location = `${to}${slug}`;
  });

  const checkWeddingPreviewBySlug = (nextState, replaceState, callback) => {
    const { dispatch } = store;
    const { slug } = nextState.params;
    dispatch(getWeddingPreviewBySlug(slug))
      .then(() => {
        const state = store.getState();
        if (state.publicWebsite.error) {
          replaceState('/notfound');
        }
        callback();
      }).catch(() => {
        replaceState('/notfound');
        callback();
      });
  };

  const checkGetUser = (nextState, replaceState, callback) => {
    const { dispatch } = store;
    dispatch(getUserContext())
      .then(() => callback());
  };

  const checkWeddingByHashId = (nextState, replaceState, callback) => {
    const { dispatch } = store;
    const { hashId } = nextState.params;
    dispatch(getWeddingByHashId(hashId))
      .then(() => {
        const state = store.getState();
        if (state.publicWebsite.error) {
          replaceState('/notfound');
        }
        callback();
      }).catch(() => {
        replaceState('/notfound');
        callback();
      });
  };

  const checkWeddingWithToken = (nextState, replaceState, callback) => {
    const { dispatch } = store;
    const { slug } = nextState.params;
    const token = nextState.location.query.preview_token;
    if (token) {
      dispatch(storeMobileToken(token));
      fetch('/web-api/v1/auth/mobile-website-preview',
        {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ token })
        })
        .then(() => {
          dispatch(getWeddingBySlug(slug))
            .then(() => {
              callback();
            }).catch(() => {
              replaceState('/notfound');
              callback();
            });
        }).catch(() => {
          replaceState('/notfound');
          callback();
        });
    } else {
      dispatch(getWeddingBySlug(slug))
        .then(() => {
          callback();
        })
        .catch((e) => {
          if (e.response && e.response.status === 403) {
            replaceState(`/wedding/${slug}/passcode`);
          } else {
            replaceState('/notfound');
          }
          callback();
        });
    }
  };

  const checkWeddingSlug = (nextState, replaceState, callback) => {
    const { dispatch } = store;
    const { slug } = nextState.params;

    dispatch(getWeddingBySlug(slug))
      .then(() => {
        replaceState(`/wedding/${slug}`);
        callback();
      })
      .catch((e) => {
        if (e.response && !(e.response.status === 403)) {
          replaceState('/notfound');
        }
        callback();
      });
  };

  const checkLogin = (nextState, replaceState, callback) => {
    const { dispatch } = store;
    dispatch(getUserContext())
      .then(() => {
        const state = store.getState();
        const product = nextState && nextState.location && nextState.location.query && nextState.location.query.product;
        if (!state.user.userContext || state.user.userContext.is_guest) {
          replaceState('/wedding/login');
        } else if (state.user.userContext.has_completed_onboarding) {
          switch (product) {
            case 'REGISTRY':
              if (state.user.userContext.has_registry) {
                replaceState('/registry/dashboard');
              } else {
                window.location.href = '/onboard/new';
                return;
              }
              break;
            case 'SAVE_THE_DATE':
              replaceState('/wedding-planning/save-the-date/shop');
              break;
            case 'INVITATIONS':
              replaceState('/wedding-planning/invitations/shop');
              break;
            default:
              // All WEDDINGS component routes should be redirected to the dashboard.
              replaceState('/wedding/manage');
              break;
          }
        } else if (!state.user.userContext.has_completed_onboarding && product === 'REGISTRY') {
          window.location.href = '/onboard/new';
          return;
        }
        callback();
      }).catch(() => {
        replaceState('/wedding/login');
        callback();
      });
  };

  // Confirm a user is not logged in before displaying pre-auth onboarding routes.
  const confirmPreAuth = (nextState, replaceState, callback) => {
    const { dispatch } = store;
    dispatch(getUserContext())
      .then(() => {
        const state = store.getState();
        if (state.user.userContext && !state.user.userContext.is_guest) {
          window.location.href = '/';
          return;
        }
        callback();
      })
      .catch(() => {
        window.location.href = '/';
      });
  };

  const checkLoginAndRedirectToReferralPage = (nextState, replaceState, callback) => {
    const { dispatch } = store;
    dispatch(getUserContext())
      .then(() => {
        const state = store.getState();
        // if user is guest or user is "idle" (been logged in for more than 30 minutes), then redirect them to login page
        if (!state.user.userContext || state.user.userContext.is_guest || state.user.userContext.status === 'IDLE') {
          browserHistory.push({ pathname: '/wedding/login', state: { referralPage: window.location.pathname } });
        } else if (state.user.userContext.has_wedding_account || state.user.userContext.has_registry) {
          callback();
        }
        callback();
      }).catch(() => {
        replaceState('/wedding/login');
        callback();
      });
  };


  // checks for a specific requirement and if it doesn't exist, redirects them to another page
  const checkForRequirement = requirement => (nextState, replaceState, callback) => {
    const state = store.getState();
    const { slug } = state.user.userContext.user_role_account_weddings[0];
    const registry = state.user.userContext.has_registry;
    const wedding = state.user.userContext.has_wedding_account;
    const onboarding = state.user.userContext.has_completed_onboarding;

    if (requirement === 'slug' && !slug) {
      window.location = '/account/settings/info';
    } else if (requirement === 'registryOrWedding' && !registry && !wedding) {
      window.location = '/account/settings/info';
    } else if (requirement === 'onboarding' && !onboarding) {
      window.location = '/wedding/onboard';
    } else {
      // if doesn't meet the requirements, then call `callback` (aka send them back to the original page);
      callback();
    }
  };

  const checkWeddingAccount = (nextState, replaceState, callback) => {
    const handleFail = () => {
      // User does not have wedding account, Check for invitations account for routeing to wedding->Registry onboarding
      const state = store.getState();
      const hasCompletedOnboarding = state.user.userContext.has_completed_onboarding; // User Context fetched onEnter of /wedding.
      if ((nextState.location.pathname === '/wedding/manage/registry-onboard')
        || (nextState.location.pathname === '/wedding/manage/registry')) {
        // Ensure they have completed onboarding
        if (!hasCompletedOnboarding) {
          replaceState('/wedding/onboard?product=REGISTRY');
        }
      } else {
        // All other wedding/manage routes require a wedding account.
        replaceState('/wedding-planning');
      }
      callback();
    };

    const currentState = store.getState();
    if (currentState.user.userContext.is_guest) {
      handleFail();
      return;
    }

    const { dispatch } = store;
    dispatch(fetchWeddingAccount())
      .then(() => {
        const state = store.getState();

        if (!(state.wedding.account && state.wedding.account.account_id)) {
          replaceState('/wedding-planning');
        }

        callback();
      }).catch(handleFail);
  };

  const checkRegistryAndRedirect = (nextState, replaceState, callback) => { // eslint-disable-line no-unused-vars
    const { dispatch } = store;

    dispatch(getUserContext())
      .then(() => {
        const state = store.getState();
        if (state.user.userContext.registry_ids.length > 0) {
          window.location = '/registry/dashboard';
        } else {
          window.location = '/onboard/new';
        }
      }).catch(() => {
        window.location = '/onboard/new';
      });
  };

  // stops a user with a wedding account from seeing /wedding/designs.
  const checkWedding = ({ redirectTo }) => (
    (nextState, replaceState, callback) => {
      const { dispatch } = store;
      dispatch(getUserContext())
        .then(() => {
          const state = store.getState();
          if (state.user.userContext.has_wedding_account) {
            window.location = redirectTo;
          } else {
            callback();
          }
        }).catch(() => {
          callback();
        });
    }
  );

  const checkWeddingAccountForLP = (nextState, replaceState, callback) => {
    const { dispatch } = store;
    dispatch(getUserContext())
      .then(() => {
        const state = store.getState();
        if (state.user.userContext.has_wedding_account) {
          replaceState('/wedding/manage');
        }
        callback();
      }).catch(() => {
        callback();
      });
  };

  const checkWeddingAccountForLP2 = (nextState, replaceState, callback) => {
    const { dispatch } = store;
    dispatch(getUserContext())
      .then(() => {
        const state = store.getState();
        if (state.user.userContext.has_wedding_account) {
          replaceState('/wedding/manage');
        } else if (!state.user.userContext.has_registry) {
          replaceState('/wedding-planning');
        }
        callback();
      }).catch(() => {
        replaceState('/wedding-planning');
        callback();
      });
  };

  const checkPromotionKey = (nextState, replaceState, callback) => {
    const { dispatch } = store;
    const { pkey } = nextState.params;
    dispatch(fetchPromotion(pkey))
      .then((promotion) => {
        const state = store.getState();
        if (promotion.business_unit === 'WEDDING_REGISTRY') {
          window.location = `/wedding-registry/promotion/${pkey}`;
        } else if (state.user.userContext.has_wedding_account) {
          window.location = ('/wedding/manage');
        } else {
          callback();
        }
      }).catch(() => {
        replaceState('/wedding-planning');
        callback();
      });
  };

  const isOnboarding = (nextState, replaceState, callback) => {
    const { dispatch } = store;
    dispatch(fetchWeddingAccount())
      .then(() => {
        const state = store.getState();
        if (!state.wedding.account.disable_website_onboarding) {
          replaceState('/wedding/manage/website/designs');
        }
        callback();
      }).catch(() => {
        replaceState('/wedding-planning');
        callback();
      });
  };

  const checkEvent = (nextState, replaceState, callback) => {
    const { dispatch } = store;
    const { eventUUID } = nextState.params;
    dispatch(fetchEventsRsvpPage())
      .then(() => {
        const { events } = store.getState().events;
        const eventId = events.uuidToId[eventUUID];
        if (!eventId) {
          replaceState('/wedding/manage/guests/rsvps/overview');
        }
        callback();
      })
      .catch(() => {
        replaceState('/wedding/manage/guests/rsvps/overview');
        callback();
      });
  };

  const checkGuestRequests = (nextState, replaceState, callback) => {
    const { dispatch } = store;
    dispatch(getGuestRequestCount())
      .then(() => getGuestRequestCount())
      .then(() => {
        const notificationCount = store.getState().publicWebsite.guestRequestCount;
        if (notificationCount === 0) {
          replaceState('/wedding/manage/guests/all');
        }
        callback();
      })
      .catch(() => {
        replaceState('/wedding/manage/guests/all');
        callback();
      });
  };

  const checkGuestByUUID = (nextState, replaceState, callback) => {
    const { dispatch } = store;
    const nextParams = nextState.params;
    const { slug, uuid } = nextParams;
    if (uuid) {
      dispatch(getRsvpByGuestGroupUuid(uuid))
        .then(() => {
          callback();
        })
        .catch(() => {
          replaceState(`/wedding/${slug}/rsvp`);
          callback();
        });
    } else {
      replaceState(`/wedding/${slug}/rsvp`);
      callback();
    }
  };

  // Fetch seating chart by uuid
  const fetchSeatingChart = (nextState, replaceState, callback) => {
    const { dispatch } = store;
    const { uuid } = nextState.params;
    if (uuid != null) {
      dispatch(fetchChart(uuid))
        .catch(() => {
          replaceState('/notfound');
          callback();
        })
        .then(() => {
          dispatch(finishOnboarding());
          dispatch(fetchChartList())
            .then(() => callback());
        });
    } else { // To handle browser back/forward buttons during/directly after onboarding (will need to change with more entry points)
      const state = store.getState();
      if (state.seatingChart != null && state.seatingChart.onboarding) {
        callback();
      } else {
        replaceState('/wedding/manage/events');
        callback();
      }
    }
  };

  // onEnter hook used for customization flow
  const onEnterCustomizationFlow = (nextState, replaceState, callback) => {
    const { projectUUID } = nextState.params;
    const { dispatch } = store;
    const state = store.getState();
    // Some cleanup to restore reducer state for errors and customization toggles
    dispatch(customizationCleanUp());
    if (state.user.hasIdentified && state.user.userContext.has_invitation_account) {
      dispatch(fetchWeddingAccount());
      dispatch(projectActions.getProjectAuthenticated(projectUUID))
        .then((ownsProject) => {
          if (!ownsProject) {
            replaceState('/wedding-planning/');
            callback();
          }
          if (getProjectUUID(state) === projectUUID) { // eslint-disable-line
            callback();
          } else {
            dispatch(projectActions.fetchProject(projectUUID)).then((project) => {
              const { completed_at: completed } = project;
              if (completed) {
                replaceState('/wedding-planning/projects/finished');
              }
              callback();
            });
          }
        });
    } else {
      replaceState('/wedding-planning/paper');
      callback();
    }
  };

  const onEnterPublicDigitalPreview = (nextState, replaceState, callback) => {
    const { projectUUID } = nextState.params;
    const { dispatch } = store;
    const state = store.getState();
    // Some cleanup to restore reducer state for errors and customization toggles
    dispatch(customizationCleanUp());
    if (state.user.hasIdentified && state.user.userContext.has_invitation_account) {
      dispatch(fetchWeddingAccount());
      dispatch(projectActions.getProjectAuthenticated(projectUUID))
        .then((ownsProject) => {
          if (!ownsProject) {
            replaceState('/wedding-planning/');
            callback();
          }
          if (getProjectUUID(state) === projectUUID) { // eslint-disable-line
            callback();
          } else {
            dispatch(projectActions.fetchProject(projectUUID)).then(() => {
              callback();
            });
          }
        });
    } else {
      replaceState('/wedding-planning/paper');
      callback();
    }
  };

  // onEnter hook used for customization steps
  const onEnterCustomizationStep = (nextState, replaceState, callback) => {
    const { projectUUID } = nextState.params;
    const state = store.getState();
    const steps = getSteps(state);
    // const { steps } = store.getState().cards.cardProject;
    const paths = nextState.location.pathname.split('/');
    const step = paths[paths.length - 1];
    if (steps[step]) {
      callback();
    } else {
      replaceState(`/wedding-planning/custom/${projectUUID}`);
      callback();
    }
  };

  const onEnterPublicDigital = (nextState, replaceState, callback) => {
    const { uuid } = nextState.params;
    const { dispatch } = store;
    dispatch(projectActions.requestPublicCard(uuid))
      .then(() => callback());
  };

  // onEnter hook for viewing digital preview
  const onEnterDigitalPreview = (nextState, replaceState, callback) => {
    console.log('onenterDigitalPreview');
    const { projectUUID } = nextState.params;
    const { dispatch } = store;
    const state = store.getState();
    if (state.user.hasIdentified && state.user.userContext.has_invitation_account) {
      dispatch(fetchWeddingAccount());
      dispatch(projectActions.getProjectAuthenticated(projectUUID))
        .then((ownsProject) => {
          if (!ownsProject) {
            replaceState('/wedding-planning/');
            callback();
          }
          if (getProjectUUID(state) === projectUUID) { // eslint-disable-line
            callback();
          } else {
            dispatch(projectActions.fetchProject(projectUUID)).then(() => {
              callback();
            });
          }
        });
    } else {
      replaceState('/wedding-planning/paper');
      callback();
    }
  };

  const onEnterDigitalComplete = (nextState, replaceState, callback) => {
    const { projectUUID } = nextState.params;
    const { dispatch } = store;
    const state = store.getState();
    if (getProjectUUID(state) === projectUUID) {
      callback();
    } else {
      dispatch(projectActions.fetchProject(projectUUID))
        .then(() => callback());
    }
  };

  const gotoOrder = (nextState, replaceState, callback) => {
    const { dispatch } = store;
    dispatch(getUserContext())
      .then(() => {
        const state = store.getState();
        if (!state.user.userContext || state.user.userContext.is_guest || !state.user.userContext.has_invitation_account) {
          replaceState('/wedding-planning/save-the-date/shop');
        }
        callback();
      }).catch(() => {
        replaceState('/notfound');
        callback();
      });
  };
  // TODO: Some of this methods are duplicates, will need to review later to remove and unify
  const onCheckCardType = (nextState, replaceState, callback) => {
    const { cardType } = nextState.params;
    const allowedCardTypes = [
      'save-the-date',
      'invitations',
      'thank-you-cards',
      'programs',
      'menus',
      'enclosures',
      'draper-james',
      'lovely-bride',
      'place-cards'
    ];

    if (!_.includes(allowedCardTypes, cardType)) {
      replaceState('/wedding-planning/paper');
    }
    callback();
  };

  const onCheckAdminCardType = (nextState, replaceState, callback) => {
    const { cardType } = nextState.params;
    const allowedCardTypes = [
      'save-the-date',
      'invitations',
      'thank-you-cards',
      'programs',
      'menus',
      'enclosures',
      'draper-james',
      'lovely-bride',
      'place-cards'
    ];

    if (!_.includes(allowedCardTypes, cardType)) {
      replaceState('/wedding-planning/paper');
    }
    callback();
  };

  const onEnterPLP = (nextState, replaceState, callback) => {
    const { dispatch } = store;
    const { cardType } = nextState.params;
    const { leadCardType, collaborator } = ROUTES_PLP_LEAD_CARD[cardType];

    dispatch(getCollaborators());
    dispatch(updateCatalogSearchFilters('lead_card_type', leadCardType));
    if (collaborator) {
      dispatch(updateCatalogSearchFilters('collaborator', collaborator));
    }
    dispatch(updateCatalogSearchFilters('active_only', true));
    dispatch(updateCatalogAdminView(false));

    callback();
  };

  const onEnterAdminPLP = (nextState, replaceState, callback) => {
    const { dispatch } = store;
    const { cardType } = nextState.params;
    const { leadCardType, collaborator } = ROUTES_PLP_LEAD_CARD[cardType];

    dispatch(getCollaborators());
    dispatch(updateCatalogSearchFilters('lead_card_type', leadCardType));
    if (collaborator) {
      dispatch(updateCatalogSearchFilters('collaborator', collaborator));
    }
    dispatch(updateCatalogSearchFilters('active_only', false));
    dispatch(updateCatalogAdminView(true));

    callback();
  };

  const onEnterPDP = (nextState, replaceState, callback) => {
    const { dispatch } = store;
    const { uuid, cardType } = nextState.params;

    dispatch(updateCatalogAdminView(false));

    dispatch(getCardSuite(uuid))
      .then(() => {
        callback();
      })
      .catch(() => {
        replaceState(`/wedding-planning/${cardType}/shop`);
        callback();
      });
  };

  const onEnterAdminPDP = (nextState, replaceState, callback) => {
    const { dispatch } = store;
    const { uuid, cardType } = nextState.params;

    dispatch(updateCatalogAdminView(true));

    dispatch(getCardSuite(uuid, true))
      .then(() => {
        callback();
      })
      .catch(() => {
        replaceState(`/wedding-planning/admin/${cardType}/shop`);
        callback();
      });
  };

  return (
    <Route component={App} onEnter={checkGetUser}>
      <Route
        path="addr/:hashId"
        getComponent={(location, callback) => {
          require.ensure([], (require) => {
            callback(null, require('./components/collectAddress/').default);
          }, 'CollectAddresses');
        }}
        onEnter={checkWeddingByHashId}
      />
      <Route
        path="address/:slug"
        getComponent={(location, callback) => {
          require.ensure([], (require) => {
            callback(null, require('./components/collectAddress/').default);
          }, 'CollectAddresses');
        }}
        onEnter={checkWeddingPreviewBySlug}
      />

      {/* WEDDING  */}
      <Route
        path="/wedding-planning"
        onEnter={checkGetUser}
        component={PreAuthApp}
      >
        <IndexRoute
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./pages/preauth/PlanningV2/PlanningV2').default);
            }, 'Planning');
          }}
          onEnter={checkWeddingAccountForLP}
        />
        <Route
          path="website"
          onEnter={checkWedding({ redirectTo: '/wedding/manage/website' })}
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./pages/preauth/WebsiteV2').default);
            }, 'WebsiteV2');
          }}
        />
        <Route
          path="website/designs"
          onEnter={checkWedding({ redirectTo: '/wedding/manage/website/designs' })}
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./pages/preauth/ThemesContainerV2').default);
            }, 'PreAuthThemesV2');
          }}
        />
        <Route
          path="website/design/:themeKey"
          onEnter={checkWedding({ redirectTo: '/wedding/manage/website/designs' })}
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./pages/preauth/ThemeDetail').default);
            }, 'ThemeDetail');
          }}
        />
        <Route
          path="checklist"
          onEnter={checkWedding({ redirectTo: '/wedding/manage/checklist' })}
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./pages/preauth/ChecklistV2').default);
            }, 'PreAuthChecklist');
          }}
        />
        <Route
          path="guests"
          onEnter={checkWedding({ redirectTo: '/wedding/manage/guests/all' })}
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./pages/preauth/GuestListV2').default);
            }, 'GuestList');
          }}
        />
        {/* INVITATION LANDING  */}
        <Route
          path="invitations"
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./pages/preauth/HomeInvitation').default);
            }, 'HomeInvitation');
          }}
        />
        {/* GENERIC PAPER LANDING  */}
        <Route
          path="paper"
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./pages/preauth/InvitationsLanding/InvitationsLandingContainer').default);
            }, 'HomeInvitation');
          }}
        />
        {/* SAVE-THE-DATE LANDING  */}
        <Route
          path="save-the-date"
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./pages/preauth/HomeSaveTheDate').default);
            }, 'HomeSaveTheDate');
          }}
        />
      </Route>
      {/* END --- WEDDING */}

      <Route
        path="/wedding-planning"
        getComponent={(location, callback) => {
          require.ensure([], (require) => {
            callback(null, require('./cards/pages/Cards').default); // Cards
          }, 'Cards');
        }}
      >
        <Route path="/digital">
          <IndexRedirect to="/" />
          <Route
            path=":uuid"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./cards/pages/PublicDigitalCard').default);
              }, 'PublicDigitalCard');
            }}
            onEnter={onEnterPublicDigital}
          />
        </Route>
        <Route
          path="digitalPreview/:projectUUID"
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./cards/pages/DigitalViewCard').default);
            }, 'DigitalViewCard');
          }}
          onEnter={onEnterDigitalPreview}
        />
        <Route
          path="digitalOrder/:projectUUID"
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./cards/pages/DigitalViewCard').default);
            }, 'DigitalViewCard');
          }}
          onEnter={onEnterPublicDigitalPreview}
        />
        { // digital checkout confirmation
          FeatureFlags.get('digitalStageTwo') && (
            <Route
              path="digitalComplete/:projectUUID"
              getComponent={(location, callback) => {
                require.ensure([], (require) => {
                  callback(null, require('./cards/components/CustomizationV2/digitalSteps/DigitalCompletion/DigitalCompletion').default);
                }, 'DigitalCompletion');
              }}
              onEnter={onEnterDigitalComplete}
            />
          )}

        {/* Old Project drafts and orders routes */
          !FeatureFlags.get('multiMediaDraftsOrders') && (
            <Route
              path="projects"
              getComponent={(location, callback) => {
                require.ensure([], (require) => {
                  callback(null, require('./cards/pages/CardProjects').default);
                }, 'CardProjects');
              }}
            >
              <IndexRedirect to="drafts" />
              <Route
                path="drafts"
                getComponent={(location, callback) => {
                  require.ensure([], (require) => {
                    callback(null, require('./cards/components/ProjectDrafts/ProjectDrafts').default);
                  }, 'ProjectDrafts');
                }}
                onEnter={gotoOrder}
              />
              <Route
                path="finished"
                getComponent={(location, callback) => {
                  require.ensure([], (require) => {
                    callback(null, require('./cards/components/ProjectOrders/ProjectOrders').default);
                  }, 'ProjectOrders');
                }}
                onEnter={gotoOrder}
              />
            </Route>
          )}
        {/* New drafts and orders */
          FeatureFlags.get('multiMediaDraftsOrders') && (
            <Route
              path="projects"
              getComponent={(location, callback) => {
                require.ensure([], (require) => {
                  callback(null, require('./cards/pages/CardProjects_v2').default);
                }, 'CardProjects');
              }}
            >
              <IndexRedirect to="drafts" />
              <Route
                path="drafts"
                getComponent={(location, callback) => {
                  require.ensure([], (require) => {
                    callback(null, require('./cards/components/ProjectDrafts/ProjectDrafts_v2').default);
                  }, 'ProjectDrafts');
                }}
                onEnter={gotoOrder}
              />
              <Route
                path="finished"
                getComponent={(location, callback) => {
                  require.ensure([], (require) => {
                    callback(null, require('./cards/components/ProjectOrders/ProjectOrders_v2').default);
                  }, 'ProjectOrders');
                }}
                onEnter={gotoOrder}
              />
            </Route>
          )}

        {/* Customization flow routes */}
        <Route
          path="custom/:projectUUID"
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./cards/pages/CardCustomizationFlow').default);
            }, 'CardCustomizationFlowV2');
          }}
          onEnter={onEnterCustomizationFlow}
        >
          <Route
            path="digital"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./cards/components/CustomizationV2/digitalSteps/DigitalCard').default);
              }, 'DigitalCard');
            }}
            onEnter={onEnterCustomizationStep}
          />
          <Route
            path="guests"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./cards/components/CustomizationV2/steps/Addressing/AddressingV2').default);
              }, 'Guests');
            }}
            onEnter={onEnterCustomizationStep}
          />
          <Route
            path="review"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./cards/components/CustomizationV2/digitalSteps/DigitalReview/DigitalReview').default);
              }, 'DigitalReview');
            }}
            onEnter={onEnterCustomizationStep}
          />
          <Route
            path="detailFront"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./cards/components/CustomizationV2/steps/EventDetailFront').default);
              }, 'EventDetailFrontV2');
            }}
            onEnter={onEnterCustomizationStep}
          />
          <Route
            path="detailBack"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./cards/components/CustomizationV2/steps/EventDetailBack').default);
              }, 'EventDetailBackV2');
            }}
            onEnter={onEnterCustomizationStep}
          />
          <Route
            path="rsvp"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./cards/components/CustomizationV2/steps/RSVP').default);
              }, 'RSVPV2');
            }}
            onEnter={onEnterCustomizationStep}
          />
          <Route
            path="rsvpEnvelope"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./cards/components/CustomizationV2/steps/RSVPEnvelope').default);
              }, 'RsvpEnvelopeV2');
            }}
            onEnter={onEnterCustomizationStep}
          />
          <Route
            path="envelope"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./cards/components/CustomizationV2/steps/Envelope').default);
              }, 'EnvelopeV2');
            }}
            onEnter={onEnterCustomizationStep}
          />
          <Route
            path="recipients"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./cards/components/CustomizationV2/steps/Recipients/Recipients').default);
              }, 'Recipients');
            }}
            onEnter={onEnterCustomizationStep}
          />
          <Route
            path="addressing"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./cards/components/CustomizationV2/steps/Addressing/Addressing').default);
              }, 'Addressing');
            }}
            onEnter={onEnterCustomizationStep}
          />
          <Route
            path="addressingPreview"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./cards/components/CustomizationV2/steps/Addressing/Addressing').default);
              }, 'Addressing');
            }}
            onEnter={onEnterCustomizationStep}
          />
          <Route
            path="reviewPaper"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./cards/components/CustomizationV2/steps/Review/Review').default);
              }, 'Review');
            }}
            onEnter={onEnterCustomizationStep}
          />
        </Route>

        {/* Admin PLP and PDP routes */}
        <Route path="admin">
          <Route path=":cardType" onEnter={onCheckAdminCardType}>
            <IndexRedirect to="./" />
            <Route
              path="shop"
              getComponent={(location, callback) => {
                require.ensure([], (require) => {
                  callback(null, require('./cards/pages/CardListingPage').default); // Invitation PLP
                }, 'CardListingPage');
              }}
              onEnter={onEnterAdminPLP}
            />
            <Route
              path=":uuid"
              getComponent={(location, callback) => {
                require.ensure([], (require) => {
                  callback(null, require('./cards/pages/CardDetailPage').default);
                }, 'CardDetailPage');
              }}
              onEnter={onEnterAdminPDP}
            />
          </Route>
        </Route>

        {/* PLP and PDP routes */}
        <Route path=":cardType" onEnter={onCheckCardType}>
          <IndexRedirect to="./" />
          <Route
            path="shop"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./cards/pages/CardListingPage').default); // Invitation PLP
              }, 'CardListingPage');
            }}
            onEnter={onEnterPLP}
          />
          <Route
            path=":uuid"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./cards/pages/CardDetailPage').default);
              }, 'CardDetailPage');
            }}
            onEnter={onEnterPDP}
          />
        </Route>
      </Route>

      {/* Preauth onboarding pages */}
      <Route path="/onboard">
        <Route path="signup" component={SignupPageContainer} onEnter={confirmPreAuth} />
        <Route path="login" component={LoginPageContainer} onEnter={confirmPreAuth} />
        <Route path="forgot" component={ForgotPasswordPage} onEnter={confirmPreAuth} />
        <Route path="select-product" component={SignupIntent} onEnter={confirmPreAuth} />
        <IndexRedirect to="select-product" component={SignupIntent} />
      </Route>
      <Route path="/wedding" onEnter={checkGetUser}>
        <IndexRedirect to="/wedding-planning" />
        <Route
          path="mobile-landing"
          component={MobileLandingPage}
        />
        <Route
          path="guest-help"
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./pages/GuestHelp').default);
            }, 'GuestHelp');
          }}
        />
        <Route component={PreAuthApp}>
          <Route
            path="from-registry"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./pages/preauth/Planning').default);
              }, 'WeddingsLP');
            }}
            onEnter={checkWeddingAccountForLP2}
          />
          <Route
            path="promotion/:pkey"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./pages/preauth/Planning').default);
              }, 'Promotion');
            }}
            onEnter={checkPromotionKey}
          />
          <Route
            path="promotional/:pkey"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./pages/preauth/Planning').default);
              }, 'Promotional');
            }}
            onEnter={checkPromotionKey}
          />
        </Route>
        <Route
          path="login"
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./pages/Login').default);
            }, 'Login');
          }}
        />
        <Route
          path="onboard"
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./components/onboard').default);
            }, 'Onboard');
          }}
        >
          <IndexRoute
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./components/onboard/OnboardContainer').default);
              }, 'OnboardContainer');
            }}
          />
        </Route>
        <Route
          path="onboard/:selectedThemeId"
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./components/onboard').default);
            }, 'Onboard');
          }}
          onEnter={checkLogin}
        >
          <IndexRoute component={CreateFlow} />
        </Route>
        <Route
          path="manage"
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./pages/Manage').default);
            }, 'Manage');
          }}
          onEnter={checkWeddingAccount}
        >
          <IndexRoute
            getComponent={(location, callback) => {
              const goToEditorialNoDek = shouldGoToTestPage({
                optimizelyConfig: weddingDashboardEditorialWithNoDekOptimizelyConfig,
                isOptimizelyTestSkipped: window.zola.env === 'development',
                devStart: '2019-02-25T21:00:00.000Z', // Dev - Monday at 4pm EST, Feburary 25th, 2019
                prodStart: '2019-02-27T15:00:00.000Z', // Prod - Wednesday at 10am EST, Feburary 27th, 2019
                cookieName: 'isNewUserEditorialWithNoDekWeddingDash',
                store,
              });

              if (goToEditorialNoDek) {
                require.ensure([], (require) => {
                  callback(null, require('./pages/dashboardV6/DashboardV6').default);
                }, 'DashboardV6');
              } else {
                require.ensure([], (require) => {
                  callback(null, require('./pages/dashboardV5/DashboardV5').default);
                }, 'DashboardV5');
              }
            }}
            onEnter={checkGetUser}
          />
          <Route
            path="feed"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./components/manage/feed/Feed').default);
              }, 'Feed');
            }}
          />
          <Route
            path="events"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./pages/Events').default);
              }, 'Events');
            }}
          />
          <Route
            path="checklist"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./pages/Checklist').default);
              }, 'Checklist');
            }}
          />
          <Route
            path="registry"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./components/onboard/RegistryOnboard').default);
              }, 'Registry');
            }}
            onEnter={checkRegistryAndRedirect}
          />
          <Route
            path="registry-onboard"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./components/onboard/RegistryOnboard').default);
              }, 'Registry');
            }}
            onEnter={checkRegistryAndRedirect}
          />
          <Route
            path="guests"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./pages/Guests').default);
              }, 'Guests');
            }}
          >
            <IndexRedirect to="all" />
            <Route path="all" component={Directory} />
            <Route path="build" component={Build} />
            <Route path="envelopes" component={AddressEnvelopes} />
            <Route>
              <Route path="rsvp-notification/:rsvpUUID" component={TrackRsvpNotifications} onEnter={checkGuestRequests} />
              <Route path="rsvp-notifications" component={multipleRsvpNotifications} />
              <Route path="add-guest/:rsvpUUID" component={AddGuestPage} />
            </Route>
            <Route
              path="rsvps"
              getComponent={(location, callback) => {
                require.ensure([], (require) => {
                  callback(null, require('./components/manage/guestlist/TrackRsvpsContainer').default);
                }, 'TrackRsvpsContainer');
              }}
            >
              <IndexRedirect to="overview" />
              <Route path="overview" component={RsvpOverview} />
              <Route path=":eventUUID" component={RsvpEvent} onEnter={checkEvent} />
            </Route>
            <Route path="thank-you-notes" />
          </Route>
          {
            FeatureFlags.get('seatingChart')
              && (
              <Route>
                <Route
                  path="seating-chart"
                  getComponent={(location, callback) => {
                    require.ensure([], (require) => {
                      callback(null, require('./pages/SeatingChart').default);
                    }, 'SeatingChart');
                  }}
                  onEnter={fetchSeatingChart}
                />
                <Route
                  path="seating-chart/:uuid"
                  getComponent={(location, callback) => {
                    require.ensure([], (require) => {
                      callback(null, require('./pages/SeatingChart').default);
                    }, 'SeatingChart');
                  }}
                  onEnter={fetchSeatingChart}
                />
              </Route>
              )
          }
          <Route
            path="website"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./pages/Website').default);
              }, 'Website');
            }}
          >
            <IndexRedirect to="manage" />
            <Route
              path="pages"
              onEnter={isOnboarding}
              getComponent={(location, callback) => {
                require.ensure([], (require) => {
                  callback(null, require('./components/manage/website/Pages').default);
                }, 'Pages');
              }}
            >
              <IndexRedirect to="home" />
              <Route path=":pageKey" component={EditPage} />
            </Route>
            <Route
              path="manage"
              onEnter={isOnboarding}
              component={
                FeatureFlags.get('newManagePageRedesign') && inOptimizelyExperiment(managePageRedesignOptimizelyVariation1) ? ManagePagesRedesign : ManagePages}
            />
            <Route
              path="themes"
              onEnter={redirect({ to: '/wedding/manage/website/designs' })}
              component={ThemesContainer}
            />
            <Route
              path="theme/:themeKey"
              onEnter={redirect({ to: '/wedding/manage/website/design', useSlug: 'themeKey' })}
            />
            <Route path="designs" component={ThemesContainer} />
            <Route path="design/:themeKey" component={ThemeDetail} />
          </Route>
        </Route>
        <Route path="credits" component={Credits} />
        <Route
          path=":slug/passcode"
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./pages/Passcode').default);
            }, 'Passcode');
          }}
          onEnter={checkWeddingSlug}
        />
        <Route
          path=":slug"
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./pages/Public').default);
            }, 'Public');
          }}
          onEnter={checkWeddingWithToken}
        >
          <IndexRoute component={Home} />
          <Route path="event" component={Events} />
          <Route path="faq" component={Faq} />
          <Route path="wedding_party" component={WeddingPartyV2} />
          <Route path="registry" component={Registry} />
          <Route path="poi" component={(FeatureFlags.get('googleApiReduction')) ? PoiV2 : Poi} />
          <Route path="photo" component={Photos} />
          <Route path="travel" component={Travel} />
          <Route
            path="rsvp"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./components/PublicWebsite/pages/RsvpBase').default);
              }, 'RsvpBase');
            }}
          >
            <Route path=":uuid" component={RsvpBase} onEnter={checkGuestByUUID} />
          </Route>
        </Route>
        <Route path="/notfound" component={NotFoundv2} />
        <Route path="*" component={NotFoundv2} />
      </Route>
      {/* START --- new account pages */}
      <Route path="/account" onEnter={checkLoginAndRedirectToReferralPage}>
        <Route
          path="settings"
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./pages/AccountSettings').default);
            }, 'AccountSettings');
          }}
          onEnter={checkGetUser}
        >
          <Route
            path="urls"
            component={UrlContainer}
            onEnter={checkForRequirement('slug')}
          />
          <Route
            path="wedding"
            component={WeddingDetailsContainer}
            onEnter={checkForRequirement('onboarding')}
          />
          <Route
            path="privacy"
            component={PrivacySettings}
            onEnter={checkForRequirement('registryOrWedding')}
          />
        </Route>
      </Route>
      {/* EXTERNAL REDIRECTS - there might be a better way to do this */}
      <Route path="/registry/dashboard" component={() => { window.location = '/registry/dashboard'; }} />
    </Route>
  );
};

export default getRoutes;



// WEBPACK FOOTER //
// ./src/routes.jsx